import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TransformerPhasesLegend } from '../../../models/infraestructure.models';

@Component({
  selector: 'ui-transformer-phases-legend',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <div
      class="w-fit flex flex-row gap-x-6 bg-gray-100 rounded-full px-5 mx-auto mt-6"
    >
      @for (item of legend(); track item.label) {
        <div class="flex items-baseline gap-x-1">
          <span class="text-gray-500 text-[12px]">{{ item.label }}</span>
          <span class="text-base whitespace-nowrap">
            {{ formatValue(item.value) }}
          </span>
        </div>
      }
    </div>
  `,
})

export class TransformerLegendComponent {
  legend = input<TransformerPhasesLegend[]>([
    { label: '', value: 0 },
    { label: '', value: 0 },
    { label: '', value: 0 },
  ]);

formatValue(value: string | number): string {
  if (typeof value === 'string') {
    // Separate number and unit (example: "103,89999999999999 A")
    const match = value.match(/^([\d,.]+)\s*(\w*)$/);
    if (match) {
      let numStr = match[1].replace(',', '.'); // Convert to JS numeric format
      let unit = match[2] || '';
      let num = parseFloat(numStr);
      // Limit to two decimals and switch back to comma
      let formattedNum = num.toFixed(2).replace('.', ',');
      return unit ? `${formattedNum} ${unit}` : formattedNum;
    }
    // If no match, return the original string
    return value;
    } else {
    // For numbers, use toLocaleString
    return value.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
}
}
